import React from "react";

const SvgFacebook = props => <svg width={10} height={20} viewBox="0 0 10 20" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6.667 6.667H10L9.583 10H6.667v10H2.344V10H0V6.667h2.344v-2.24c0-1.458.364-2.56 1.094-3.307C4.167.373 5.381 0 7.082 0H10v3.333H8.23c-.66 0-1.086.104-1.277.313-.19.208-.286.555-.286 1.042v1.979z" fill="currentColor" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/facebook_f060e5.svg";
export { SvgFacebook as ReactComponent };